import { Typography } from "@mui/material";
import React from "react";

const MUIErrorText = ({ ErrorMessage }) => {
  return (
    <React.Fragment>
      <Typography color="error" variant="caption" className="inter-regular-400">
        {ErrorMessage}
      </Typography>
    </React.Fragment>
  );
};

export default MUIErrorText;
